var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15.586l-3.5 3.5-7.5-7.5-6 6V5h22v15.586l-5-5zM27 27H5v-6.586l6-6 9.421 9.42 1.414-1.413-1.92-1.921L22 18.414l5 5V27zm1-24H4a1 1 0 00-1 1v24a1 1 0 001 1h24a1 1 0 001-1V4a1 1 0 00-1-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 11.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0"
  })))));
}

export default SvgIconPhoto;